import React from "react";

function ModaNotice() {
  return <div>ModaNotice</div>;
}

export default ModaNotice;
